"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateTerminalGeneratePINForUser = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const terminalGeneratePINForUserMutation = (0, client_1.gql) `
  mutation TerminalGeneratePINForUser($workspaceId: ID!, $userId: ID!, $useEmployeeId: Boolean) {
      terminalGeneratePINForUser(workspace: $workspaceId, user: $userId, useEmployeeId: $useEmployeeId)
    }`;
const mutateTerminalGeneratePINForUser = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(terminalGeneratePINForUserMutation, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.terminalGeneratePINForUser;
};
exports.mutateTerminalGeneratePINForUser = mutateTerminalGeneratePINForUser;
